"use client";

import type { OverlayMenuBaseProps } from "@/app/components/menu/overlayMenuSystem";
import PolicyLinksText from "../policies/policyLinksText";
import styles from "./valuePropsSection.module.scss";

export const MONEY_BACK_GUARANTEE_TITLE = "Net32 Money Back Guarantee";

export default function MoneyBackGuaranteeMenu({ closeCallback }: OverlayMenuBaseProps) {
  return (
    <div className={styles.guaranteeDetails} data-money-back-guarantee-drawer>
      <div className={styles.guarantee}>
        <p className={styles.guaranteeLead}>
          If you&apos;re not happy with your purchase, Net32 will fully reimburse you under our 30 Day Unconditional
          Money Back Guarantee.
        </p>
        <div className={styles.guaranteeBody}>
          <p>
            Net32 works with trusted vendors, manufacturers, and distributors to help provide reliable products,
            responsive service, and a better purchasing experience.
          </p>
          <p>
            If a product does not meet expectations and is not covered by a manufacturer or vendor guarantee, Net32 will
            help make it right. We may provide a prepaid return label and arrange a replacement or reimbursement, based
            on the issue and eligibility.
          </p>
          <p>
            No additional return shipping charges apply when the return is approved under the Net32 30-Day Money-Back
            Guarantee.
          </p>
        </div>
      </div>
      <div className={styles.policies}>
        <h3 className={styles.policiesTitle}>Return Policy &amp; Shipping Policy</h3>
        <PolicyLinksText
          className={styles.policiesText}
          linkClassName={styles.link}
          trackingAttribute="data-money-back-guarantee-link"
          onVendorListClick={closeCallback}
        />
      </div>
    </div>
  );
}
